module.exports = [
  { key: '', name: 'All' },
  { key: 'marketing', name: 'Marketing' },
  { key: 'design', name: 'Design' },
  { key: 'user-experience', name: 'User Experience' },
  { key: 'no-code-hacks', name: 'No-Code Hacks' },
  { key: 'product', name: 'Product' },
  { key: 'real-life-wins', name: 'Real-Life Wins' },
  { key: 'ecommerce', name: 'E-Commerce' },
];
